module.exports = __webpack_public_path__ + "img/app_default_img6.2ad5d901.png";